// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3BJmt","label":"Labeled_label__1xc44","divider":"Labeled_divider__16CT7"};